import { Typography } from "@mui/material";

import styled from "styled-components";

import { isSmallDesktop } from "@/hooks/layout";

export const MainTextTypography = styled(Typography)`
  color: #ffffff;
  font-family: "Cormorant Garamond", serif;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.2;
  text-align: center;

  ${isSmallDesktop} {
    font-size: 1.8rem;
  }
`;

export const AdditionalTextTypography = styled(Typography)`
  color: #e0d2c1;
  text-align: center;
  font-family: "Raleway", sans-serif;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
`;
